module.exports = __webpack_public_path__ + "img/temperature.8f6ee8a7.svg";